import { connect } from 'react-redux';
import { validateUserRegistration } from '@alphapoint/apex-web/lib/redux/actions/kycJumioActions';
import { kycVerificationLevelsSelector } from '@alphapoint/apex-web/lib/redux/selectors/kycLevelsSelectors';
import KYCSumSubSdk from './KYCSumSubSdk';

const mapStateToProps = (state) => {
  const kycData = kycVerificationLevelsSelector(state);
  const { verificationLevel, kycConfig } = kycData;

  return {
    kycConfig,
    verificationLevel,
  };
};

const mapDispatchToProps = {
  validateUserRegistration,
};

const KYCSumSubSdkContainer = connect(mapStateToProps, mapDispatchToProps)(KYCSumSubSdk);

export default KYCSumSubSdkContainer;
